import React, { useState } from "react";

import { getUnitOptions } from "./Helper";
import MRLCountryList from "./MRLCountryList";
import SpecManagerSelect from "./SpecManagerSelect";
import SpecsQualitative from "./SpecsQualitative";
import SpecsQuantitative from "./SpecsQuantitative";
import SpecsRange from "./SpecsRange";

import { hasPermission, permissions } from "../../../../../utils/Permissions";

import { ReactComponent as MRLIcon } from "../../../../../assets/images/product/MRLIcon.svg";
import { ReactComponent as QualitativeIcon } from "../../../../../assets/images/product/QualitativeIcon.svg";
import { ReactComponent as QuantitativeIcon } from "../../../../../assets/images/product/QuantitativeIcon.svg";
import { ReactComponent as RangeIcon } from "../../../../../assets/images/product/RangeIcon.svg";

import "./TestSpecForm.css";

function TestSpecForm({
  dataOfSpecEditing,
  handleDataChange: commitDataChange,
  unitOptions: unitOptionsProp,
}) {
  const [newQualitative, setNewQualitative] = useState(false);

  const handleDataChange = (indexOfRowClicked, fieldName, newFieldValue) => {
    if (fieldName === "test_type") {
      if (dataOfSpecEditing[indexOfRowClicked].test_type !== newFieldValue) {
        dataOfSpecEditing[indexOfRowClicked].test_type = newFieldValue;
        dataOfSpecEditing[indexOfRowClicked].specs = [];

        if (newFieldValue === "qualitative") {
          setNewQualitative(true);
        }
      }
    } else if (fieldName === "specs") {
      dataOfSpecEditing[indexOfRowClicked][fieldName] = newFieldValue;
    } else if (fieldName === "countries_lst") {
      // Update pesticides for all spec entries that already contain country data.
      dataOfSpecEditing.forEach((specEditingData, i) => {
        if (specEditingData.countries_lst) {
          dataOfSpecEditing[i].test_type = "";
          dataOfSpecEditing[i].specs = [];
          dataOfSpecEditing[i][fieldName] = newFieldValue;
        }
      });
    } else {
      dataOfSpecEditing.push({ [fieldName]: newFieldValue, test_type: "", specs: ["", "", ""] });
    }

    commitDataChange(dataOfSpecEditing);
  };

  const unitOptions = getUnitOptions(unitOptionsProp);

  return (
    <div className="TestSpecForm__Container">
      {dataOfSpecEditing.map((item, i) => {
        // MRL mode should be active only when the countries *list* is available.
        // (An empty array means "no country list", even if MRL is the test type on the backend.)
        const isMRL = hasPermission(permissions.global.specialPesticides)
          && Array.isArray(item.countries_lst)
          && item.countries_lst.length > 0;
        const isQualitative = item.test_type === "qualitative";
        const isRange = item.test_type === "range";
        const isQuantitative = item.test_type === "quantitative";
        const showNoTypePlaceholder = !isMRL && !isQualitative && !isRange && !isQuantitative;

        return (
          <div key={i} className="TestSpecForm__Card">
            <div className="TestSpecForm__CardHeader">
              <div className="TestSpecForm__CardHeaderStripe" />
              <div className="TestSpecForm__CardHeaderTitle">Test Standard</div>
            </div>

            <div className="TestSpecForm__CardBody">
              <div className="TestSpecForm__Row">
                <div className="TestSpecForm__RowLabel">Test Type</div>
                <div className="TestSpecForm__DropdownBox">
                  {isMRL ? (
                    <div className="TestSpecForm__MRLType">
                      <MRLIcon />
                      <span>MRL</span>
                    </div>
                  ) : (
                    <SpecManagerSelect
                      width="100%"
                      optionSelected={item.test_type || undefined}
                      options={[
                        { value: "range", icon: <RangeIcon /> },
                        { value: "quantitative", icon: <QuantitativeIcon /> },
                        { value: "qualitative", icon: <QualitativeIcon /> },
                      ]}
                      placeholder="Choose Test Type"
                      onSelect={(optionSelected) => handleDataChange(i, "test_type", optionSelected)}
                    />
                  )}
                </div>
              </div>

              <div className="TestSpecForm__Row">
                <div className="TestSpecForm__SpecRow">
                  <div className="TestSpecForm__SpecLabel">Spec</div>
                  <div className="TestSpecForm__SpecDetails">
                    {isMRL ? (
                      <MRLCountryList
                        countriesData={item.countries_lst}
                        onChange={(values) => handleDataChange(i, "countries_lst", values)}
                        editMode
                      />
                    ) : (
                      <>
                        {isQualitative && (
                          <SpecsQualitative
                            data={item.specs.length === 0 ? ["", "", ""] : item.specs}
                            handleDataChange={(newSpec) => handleDataChange(i, "specs", newSpec)}
                            newQualitative={newQualitative}
                            unitOptions={unitOptions}
                          />
                        )}

                        {isRange && (
                          <SpecsRange
                            data={item.specs.length === 0 ? ["", "", ""] : item.specs}
                            handleDataChange={(newSpec) => handleDataChange(i, "specs", newSpec)}
                            unitOptions={unitOptions}
                          />
                        )}

                        {isQuantitative && (
                          <SpecsQuantitative
                            data={item.specs.length === 0 ? ["", "", ""] : item.specs}
                            handleDataChange={(newSpec) => handleDataChange(i, "specs", newSpec)}
                            unitOptions={unitOptions}
                          />
                        )}

                        {showNoTypePlaceholder && (
                          <div className="TestSpecForm__NoType">
                            Please select test type to view the specs
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TestSpecForm;
